import { Lock, Scale, UserCheck } from "lucide-react";
import { Overline, Reveal } from "./Shared";

const POINTS = [
  {
    icon: Lock,
    title: "Confidential by design",
    body: "Your information is transmitted securely, stored with care, and never sold or shared without your consent.",
  },
  {
    icon: UserCheck,
    title: "Independent legal network",
    body: "We are a consumer intake service, not a law firm. Inquiries may be shared with independent attorneys who evaluate matters in your state.",
  },
  {
    icon: Scale,
    title: "No promises — just honesty",
    body: "We never guarantee outcomes, settlements, or eligibility. Submitting a form does not create an attorney-client relationship.",
  },
];

const TrustSection = () => (
  <section
    data-testid="trust-section"
    className="border-b border-[#E7E2DA] bg-[#1A1715] py-20 sm:py-28"
  >
    <div className="mx-auto max-w-7xl px-5 sm:px-10 lg:px-16">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
        <Reveal className="lg:col-span-4">
          <Overline className="!text-amber-500/90">Chapter 05 — Our Standard</Overline>
          <h2 className="mt-4 font-serif font-semibold text-3xl sm:text-4xl tracking-tight text-[#FBF9F5] leading-tight">
            Trust is earned in the details.
          </h2>
          <p className="mt-5 font-news text-base text-[#A8A29E] leading-relaxed">
            No fake countdowns. No fabricated testimonials. No pressure. Just a
            clear, honest intake process.
          </p>
        </Reveal>
        <div className="lg:col-span-8 grid grid-cols-1 sm:grid-cols-3 gap-px bg-[#FBF9F5]/10 border border-[#FBF9F5]/10">
          {POINTS.map((p, i) => (
            <Reveal key={p.title} delay={i * 0.1} className="bg-[#1A1715] p-8">
              <p.icon className="h-6 w-6 text-[#B45309]" strokeWidth={1.5} />
              <h3 className="mt-5 font-serif font-semibold text-xl text-[#FBF9F5]">
                {p.title}
              </h3>
              <p className="mt-3 font-sans text-sm text-[#A8A29E] leading-relaxed">
                {p.body}
              </p>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default TrustSection;
